export default function VerticalComparisonMatrix() {
  const rows = [
    ["Primary User Scale", "Millions (Citizens)", "Millions (Customers)", "Thousands (Operators)", "Billions (Users)"],
    ["Authentication Focus", "Inclusive, Multi-modal", "High Assurance, Biometric", "OT-Friendly, Shift-based", "Frictionless, Social"],
    ["Key Compliance", "IT Act, DPDP, RTI", "RBI, SEBI, PCI-DSS", "CEA, TRAI, NCIIPC", "DPDP, GDPR, SOC 2"],
    ["Critical Risk", "Citizen Data Breach", "Financial Fraud", "Service Disruption", "Account Takeover"],
    ["PAM Priority", "Classified Systems", "Core Banking, SWIFT", "SCADA, Grid Control", "Cloud, Kubernetes"],
    ["Federation Need", "Inter-Department", "Partner Ecosystem", "Vendor Access", "Multi-Cloud"],
    ["Unique Challenge", "Digital Divide", "Real-time Fraud", "IT/OT Convergence", "Rapid Scale"],
  ];

  return (
    <section className="mt-14">
      <div className="mx-auto max-w-3xl text-center">
        <div className="text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
          Vertical Comparison Matrix
        </div>
        <h2
          className="mt-3 text-2xl font-semibold tracking-tight sm:text-3xl"
          style={{ fontFamily: "var(--font-display)" }}
        >
          Identity priorities by sector
        </h2>
        <p className="mt-3 text-sm leading-7 text-[var(--text-secondary)] sm:text-base">
          Summary of key identity focus areas and tradeoffs across verticals.
        </p>
      </div>

      <div className="mt-8 overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] backdrop-blur-xl">
        <div className="overflow-x-auto">
          <table className="min-w-[980px] w-full border-collapse text-left">
            <thead>
              <tr className="bg-white/[0.02]">
                <th className="whitespace-nowrap border-b border-white/10 px-5 py-4 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
                  Capability
                </th>
                <th className="whitespace-nowrap border-b border-white/10 px-5 py-4 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
                  Government
                </th>
                <th className="whitespace-nowrap border-b border-white/10 px-5 py-4 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
                  BFSI
                </th>
                <th className="whitespace-nowrap border-b border-white/10 px-5 py-4 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
                  Infrastructure
                </th>
                <th className="whitespace-nowrap border-b border-white/10 px-5 py-4 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">
                  Digital Native
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r[0]} className="odd:bg-white/[0.01]">
                  <td className="border-b border-white/10 px-5 py-4 text-sm font-semibold text-[var(--text-primary)]">
                    {r[0]}
                  </td>
                  <td className="border-b border-white/10 px-5 py-4 text-sm text-[var(--text-secondary)]">
                    {r[1]}
                  </td>
                  <td className="border-b border-white/10 px-5 py-4 text-sm text-[var(--text-secondary)]">
                    {r[2]}
                  </td>
                  <td className="border-b border-white/10 px-5 py-4 text-sm text-[var(--text-secondary)]">
                    {r[3]}
                  </td>
                  <td className="border-b border-white/10 px-5 py-4 text-sm text-[var(--text-secondary)]">
                    {r[4]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-4 text-xs text-[var(--text-secondary)]">
        Document prepared by Centre of Excellence - Identity Practice
      </div>
    </section>
  );
}
